import {BannerDataIframe} from '@core-client/ads/banner/data/BannerDataIframe';

import {BannerRenderer} from './BannerRenderer';

export class IframeBannerRenderer extends BannerRenderer {
    showBannerDiv(banner: BannerDataIframe) {
        this.bannerView.removeOldIframe(banner.id);
        this.bannerView.showContainer();
    }
}
